const headers = new Headers();
headers.append("Content-Type", "application/json");

const configOptions = {
    method: "POST",
    headers,
}

export const tcodeViewApi = new Request(process.env.REACT_APP_TCODE_ADMIN_VIEW_API, configOptions);